// extracted by mini-css-extract-plugin
module.exports = {"buy-btn":"style_buy-btn__3uJAF","buy-btn-2021":"style_buy-btn-2021__2Ezsh"};